<template>
    <div>
        这里是首页
        <button @click="getOut">点击退出</button>
    </div>
</template>

<script>
export default {
    methods: {
        getOut() {
        this.$store.dispatch('LogOut').then(() => {
            location.reload()
        })
    }
    }
    
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/experiment/Experiment.vue